import React, { useState, useEffect } from "react";
import ContentTable from "../components/ContentTable";
import api from "../../utilis/api";

const ITEMS_PER_PAGE = 10;

const Pages = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const handlePageChange = (page) => setCurrentPage(page);

  // Fetch all data once
  const getContent = async () => {
    try {
      const res = await api.get("/content/all");
      setData(res.data.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getContent();
  }, []);

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const pagedData = data.slice(startIndex, endIndex);

  return (
    <div className="flex flex-col w-full gap-4">
      <div className="p-2 w-full bg-gray-700">
        <ContentTable
          data={pagedData}
          currentPage={currentPage}
          totalPages={Math.ceil(data.length / ITEMS_PER_PAGE)}
          onPageChange={handlePageChange}
          refreshData={getContent} // optional, so ContentTable can refresh after add/edit/delete
        />
      </div>
    </div>
  );
};

export default Pages;
